import { combineReducers } from 'redux'
import { all, fork } from 'redux-saga/effects'

import DashboardSaga from './dashboard/sagas' 
import UserSaga from './user/sagas' 
import CoursesSaga from './courses/sagas'
import UsersSaga from './users/sagas'
import UserCoursesSaga from './userCourses/sagas'
import FeedbacksSaga from './feedbacks/sagas'
import OrganisersSaga from './organisers/sagas'
import MarketingsSaga from './marketings/sagas'
import TrainersSaga from './trainers/sagas'
import ConcentrationsSaga from './concentrations/sagas'
import OrdersSaga from './orders/sagas'

import DashboardReducer from './dashboard/reducer';
import userReducer from './user/reducer';
import CoursesReducer  from './courses/reducer'
import UsersReducer from './users/reducer'
import UserCoursesReducer from './userCourses/reducer'
import FeedbacksReducer from './feedbacks/reducer'
import OrganisersReducer from './organisers/reducer'
import MarketingsReducer from './marketings/reducer'
import TrainersReducer from './trainers/reducer'
import ConcentrationsReducer from './concentrations/reducer'
import OrdersReducer from './orders/reducer'

// The top-level state object
export interface ApplicationState {
  dashboard:any
  userReducer:any
  course:any
  user:any
  userCourse:any
  feedback:any
  organiser:any
  marketing:any
  trainer: any
  concentration:any
  order:any
}

// Whenever an action is dispatched, Redux will update each top-level application state property
// using the reducer with the matching name. It's important that the names match exactly, and that
// the reducer acts on the corresponding ApplicationState property type.
export const createRootReducer = () =>
  combineReducers({
    dashboard:DashboardReducer,
    userReducer:userReducer,
    course:CoursesReducer,
    user:UsersReducer,
    userCourse:UserCoursesReducer,
    feedback:FeedbacksReducer,
    organiser:OrganisersReducer,
    marketing:MarketingsReducer,
    trainer:TrainersReducer,
    concentration:ConcentrationsReducer,
    order:OrdersReducer
  })

// Here we use `redux-saga` to trigger actions asynchronously. `redux-saga` uses something called a
// "generator function", which you can read about here:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/function*
export function* rootSaga() {
  yield all([
    fork(DashboardSaga),
    fork(UserSaga),
    fork(CoursesSaga), 
    fork(UsersSaga), 
    fork(UserCoursesSaga), 
    fork(FeedbacksSaga),
    fork(OrganisersSaga),
    fork(MarketingsSaga),
    fork(TrainersSaga),
    fork(ConcentrationsSaga),
    fork(OrdersSaga)
  ])
}
